<template>
  <div class="revise">
    <div v-if="reviseData.length != 0" class="wrapper">
      <div class="main" v-for="(item, index) in reviseData" :key="index">
        <div class="timestamp">
          <el-popover
            placement="bottom-start"
            trigger="hover"
            width="250"
            :content="$t('profile.newSbumitTime') + `:${item.submitTime}`"
          >
            <template #reference>
              <span>{{ item.submitTime }}</span>
            </template>
          </el-popover>
        </div>
        <div>
          <div class="title-status">
            <div class="title-version">
              <span class="title" @click="openTerm(index)">
                <el-popover
                  placement="bottom-start"
                  trigger="hover"
                  width="250"
                  :content="$t('profile.hoverTitle')"
                >
                  <template #reference>
                    <span>{{ item.conceptName }}</span>
                  </template>
                </el-popover>
              </span>
              <span class="version">{{ item.dicName }}</span>
            </div>
            <div class="number-status">
              <div class="number">{{ item.cid }}</div>
              <div
                v-if="item.submitState == 2"
                class="status processing-status"
              >
                {{ $t('profile.processing') }}
              </div>
              <div
                v-else-if="item.submitState == 1"
                class="status reviewing-status"
              >
                {{ $t('profile.reviewing') }}
              </div>
              <div
                v-else-if="item.submitState == 3"
                class="status published-status"
              >
                {{ $t('profile.published') }}
              </div>
              <div
                v-else-if="item.submitState == 4"
                class="status overuled-status"
              >
                {{ $t('profile.overuled') }}
              </div>
            </div>
          </div>
          <div class="content" v-show="activeIndex == index">
            <div class="content-left">
              <div
                v-if="item.biosBnCommentBoList"
                class="item"
                :class="{
                  tabsIndex:
                    (tabsIndex == 1 ||
                      (tabsIndex == 2 && !item.biosHeadCommentBoList)) &&
                    activeIndex == index,
                }"
                @click="switchTabs(1)"
              >
                <span v-html="$t('profile.conceptRevision')"></span>
                <span>({{ item.biosBnCommentBoList.length }})</span>
              </div>
              <div
                v-if="item.biosHeadCommentBoList"
                class="item"
                :class="{
                  tabsIndex:
                    (tabsIndex == 2 ||
                      (tabsIndex == 1 && !item.biosBnCommentBoList)) &&
                    activeIndex == index,
                }"
                @click="switchTabs(2)"
              >
                <span v-html="$t('profile.EntityRevision')"></span>
                <span>({{ item.biosHeadCommentBoList.length }})</span>
              </div>
            </div>
            <div class="content-right">
              <div
                v-if="
                  (tabsIndex == 1 ||
                    (tabsIndex == 2 && !item.biosHeadCommentBoList)) &&
                  activeIndex == index &&
                  item.biosBnCommentBoList
                "
              >
                <ContextTab
                  :biosBnCommentBoList="item.biosBnCommentBoList"
                  @requestData="initReviseInfo"
                />
              </div>
              <div
                v-if="
                  (tabsIndex == 2 ||
                    (tabsIndex == 1 && !item.biosBnCommentBoList)) &&
                  activeIndex == index &&
                  item.biosHeadCommentBoList
                "
              >
                <TermTab
                  :biosHeadCommentBoList="item.biosHeadCommentBoList"
                  @requestData="initReviseInfo"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="empty">
      <el-empty :image-size="50" :description="$t('profile.noData')"></el-empty>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from 'vue'
import { getRevisionInfo } from '@/api/profile'
import TermTab from '@/components/profile/revise/termTab.vue'
import ContextTab from '@/components/profile/revise/conceptTab.vue'
import { useRoute } from 'vue-router'
import { Revise } from '@/api/type'

export default defineComponent({
  components: { ContextTab, TermTab },
  setup() {
    const route = useRoute()
    const tabsIndex = ref(1 as number)
    const reviseData = ref([] as Revise[])
    const activeIndex = ref(0 as number)

    const switchTabs = (key: number) => {
      tabsIndex.value = key
    }
    const openTerm = (index: number) => {
      tabsIndex.value = 1
      activeIndex.value = index
    }
    watch(reviseData, () => {
      if (activeIndex.value > reviseData.value.length - 1) {
        activeIndex.value = 0
      }
    })
    const addZero = (num: number) => (num < 10 ? `0${num}` : num)
    const formatDate = (now: number) => {
      const time = new Date(now)
      const year = time.getFullYear()
      const month = time.getMonth() + 1
      const date = time.getDate()
      return `${year}-${addZero(month)}-${addZero(date)}`
    }
    const handleBnTimeState = (item) => {
      item.submitTime = formatDate(
        parseInt(item.biosBnCommentBoList[0].timestamp)
      )
      item.timesTamp = item.biosBnCommentBoList[0].timestamp
      item.submitState = item.biosBnCommentBoList[0].state
      return item
    }
    const handleHeadTimeState = (item) => {
      item.submitTime = formatDate(
        parseInt(item.biosHeadCommentBoList[0].timestamp)
      )
      item.timesTamp = item.biosHeadCommentBoList[0].timestamp
      item.submitState = item.biosHeadCommentBoList[0].state
      return item
    }
    const handleConcept = (val) => {
      val.timesDate = formatDate(parseInt(val.timestamp))
      val.broaderNarrow = []
      if (val.addBroaderConcepts) {
        val.addBroaderConcepts.forEach((item) => {
          val.broaderNarrow.push({ radio: '-1', text: item })
        })
      }
      if (val.addNarrowConcepts) {
        val.addNarrowConcepts.forEach((item) => {
          val.broaderNarrow.push({ radio: '1', text: item })
        })
      }
      return val
    }
    const initReviseInfo = async () => {
      const result = await getRevisionInfo()
      if (result) {
        result.forEach((item) => {
          if (item.biosBnCommentBoList && item.biosHeadCommentBoList) {
            if (
              item.biosBnCommentBoList[0].timestamp >
              item.biosHeadCommentBoList[0].timestamp
            ) {
              handleBnTimeState(item)
            } else {
              handleHeadTimeState(item)
            }
            item.biosBnCommentBoList.forEach((data) => {
              handleConcept(data)
            })
            item.biosHeadCommentBoList.forEach((data) => {
              data.timesDate = formatDate(parseInt(data.timestamp))
              data.nonBioConcept = data.nonBioConcept !== 0
            })
          } else if (item.biosBnCommentBoList) {
            handleBnTimeState(item)
            item.biosBnCommentBoList.forEach((data) => {
              handleConcept(data)
            })
          } else if (item.biosHeadCommentBoList) {
            handleHeadTimeState(item)
            item.biosHeadCommentBoList.forEach((data) => {
              data.timesDate = formatDate(parseInt(data.timestamp))
              data.nonBioConcept = data.nonBioConcept !== 0
            })
          }
          result.sort((a, b) => (b.timesTamp < a.timesTamp ? -1 : 1))
        })
        reviseData.value = result
      }
    }
    onMounted(() => {
      initReviseInfo()
      if (route.params.tabsNumber === '2') {
        tabsIndex.value = Number(route.params.tabsNumber)
      } else if (route.params.tabsNumber === '1') {
        tabsIndex.value = Number(route.params.tabsNumber)
      }
    })
    return {
      route,
      tabsIndex,
      activeIndex,
      switchTabs,
      reviseData,
      initReviseInfo,
      openTerm,
    }
  },
})
</script>
<style lang="less" scoped>
.revise {
  position: relative;
  .empty {
    margin-top: 120px;
  }
  .wrapper {
    margin: 40px 0 200px;
    .main {
      margin: 40px 0 80px 0;
      .timestamp {
        font-weight: 700;
        font-size: 14px;
        line-height: 30px;
        color: #c0c4cc;
      }
      .title-status {
        margin-top: 40px;
        padding-bottom: 18px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        border-bottom: 1px solid #dcdfe6;
        .title-version {
          .title {
            font-weight: 400;
            font-size: 24px;
            color: #0ca1bd;
          }
          .version {
            font-weight: 400;
            margin-left: 10px;
            font-size: 12px;
            color: #c0c4cc;
            white-space: nowrap;
          }
        }
        .number-status {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .number {
            margin-right: 10px;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            color: #303133;
          }
          .status {
            padding: 2px 10px;
            border-radius: 5px;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            white-space: nowrap;
          }
          .processing-status {
            border: 1.5px solid #2fcbb1;
            color: #2fcbb1;
          }
          .reviewing-status {
            border: 1.5px solid #fbb937;
            color: #fbb937;
          }
          .published-status {
            border: 1.5px solid #c0c4cc;
            color: #c0c4cc;
          }
          .overuled-status {
            border: 1.5px solid #ff7c7c;
            color: #ff7c7c;
          }
        }
      }
      .content {
        display: flex;
        justify-content: flex-start;
        border-bottom: 1px solid #dcdfe6;
        .content-left {
          width: 203px;
          border-right: 1px solid #dcdfe6;
          .item {
            padding: 10px 18px 10px 17px;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #606266;
            cursor: pointer;
            text-align: center;
            white-space: pre-wrap;
          }
          .tabsIndex {
            background: #f7f8f8;
          }
        }
        .content-right {
          flex: 1;
        }
      }
    }
  }
}
.demo-tabs .el-tabs__content {
  margin-left: 15px;
}
</style>

